package xyz.luan.bpc

import xyz.luan.bpc.operation.CentreOperation
import xyz.luan.bpc.operation.MarkingOperation
import xyz.luan.bpc.operation.StepOperation

data class Problem(
    val circles: List<Circle>,
    val centre: Centre? = null,
    val markings: Map<Double, MarkingOperation> = mapOf(),
)

data class Circle(
    val steps: List<Step>,
)

data class Step(
    val operation: StepOperation,
    val value: Double,
)

data class Centre(
    val applyTo: StepOperation,
    val operations: List<CentreOperation>,
)
